import LinkColumn, { cellType, linkColumnConfiguration } from './LinkColumn.component';

export { cellType, LinkColumn };
export default linkColumnConfiguration;
